<div
  class="qx-layout-wrapper"
>
  <sidenav
    class="qx-sidebar-container"
  >
  </sidenav>
  <div
    class="qx-main-content"
  >
    <topbar
      class="qx-topbar-container"
    >
    </topbar>
    <main
      class="qx-entity-content"
    >
      <router-outlet>
      </router-outlet>
    </main>
  </div>
</div>
